import BaseParametersFormattingStrategy from "../../parametersFormatting/BaseParametersFormattingStrategy";
import EVAReportParametersFormatter from "./ParametersFormatter"
import messageResource from "../../messageResource"
import SingleDateFormattingStrategy from '../../parametersFormatting/SingleDateFormattingStrategy'

const ParametersFormattingStrategy = function() {};

ParametersFormattingStrategy.prototype = _.create(BaseParametersFormattingStrategy.prototype, {

    init: function(selectorsData, dateFormat, productSettingsValidator, reportRightsValidator) {
        BaseParametersFormattingStrategy.prototype.init.call(this, {selectorsData, dateFormat})
        this.productSettingsValidator = productSettingsValidator;
        this.reportRightsValidator = reportRightsValidator;
        this.assignedInfo = selectorsData.assignedInfo;

        return this;
    },

    createParametersFormatter: function({selectorsData, dateFormat}) {
        return new EVAReportParametersFormatter().init({selectorsData, dateFormat})
    },

    createDateParametersFormattingStrategy: function(config) {
        return new SingleDateFormattingStrategy(config.dateFormat)
    },

    formatMainPartOfLightboxTitle: function(selectedParameters)
    {
        var showBy = BaseReportFormatUtils.formatGroupingLevel(selectedParameters.firstGroupingLevel);
        var dateParameters = this.dateParametersFormattingStrategy.formatForDateInformation(selectedParameters.dateParameters);
        return messageResource.getMessage("estimate_vs_actual_report.title", [showBy, dateParameters]);
    },

    formatParametersText: function(selectedParameters)
    {
        return this.parametersFormatter.formatCustomersAndProjectsSelection(selectedParameters.customersProjectsSelection) + "; " +
               this.parametersFormatter.formatTaskSelectionParamsString(selectedParameters.tasksConfig,
                                                                        selectedParameters.includeNotEstimated,
                                                                        selectedParameters.includeNotStarted,
                                                                        {dateSelection: selectedParameters.dateParameters.dateSelection, isParsed: true});
    }
});

export default ParametersFormattingStrategy


// WEBPACK FOOTER //
// ./web/js/reports/estimatedVsActualReport/ParametersFormattingStrategy.js